import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/developer/webhook/_webhook')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'webhook-list',
        label: 'Developers',
        to: '/developer/webhook',
      }),
    }) satisfies AggregateBreadcrumb,
});
